import React from 'react';
import EmptyState from './EmptyState';
import { useTranslation } from 'react-i18next';

const InvoicesTab: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="invoices-table-container">
      <EmptyState
        title={t('no_invoices_found')}
        description={t('no_invoices_description')}
      />
    </div>
  );
};

export default InvoicesTab;
